module.exports = __webpack_public_path__ + "img/spc-sidebar-tablet.b64e598.png";